"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateEntry = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_jss_1 = __importDefault(require("react-jss"));
const react_datepicker_1 = __importStar(require("react-datepicker"));
const fr_1 = __importDefault(require("date-fns/locale/fr"));
const lodash_flowright_1 = __importDefault(require("lodash.flowright"));
require("react-datepicker/dist/react-datepicker.css");
const icons_1 = require("../../../icons");
const dateEntry_style_1 = __importDefault(require("./dateEntry.style"));
const dateValidationRules_1 = require("../../utils/dateValidationRules");
const dateConversionRules_1 = require("../../utils/dateConversionRules");
const withInlineValidation_1 = __importDefault(require("../../wrappers/withInlineValidation"));
const links_1 = require("../../utils/links");
react_datepicker_1.registerLocale('en', fr_1.default);
const DateEntry = ({ classes, label, required, readOnly = false, todayVisible = true, hideLabel = true, id = '', onChange = () => { }, value = '', formContext = {} }) => {
    // parse the date and check for errors
    const error = !!value && !dateValidationRules_1.validYMD(value);
    // check if the widget is locked because of forms links
    const isLocked = links_1.isLockedWidget(id, formContext.links);
    // open or close calendar
    const [activeCalendar, setActiveCalendar] = react_1.useState(false);
    const calendarRef = react_1.useRef(null);
    react_1.useLayoutEffect(() => {
        if (!isLocked)
            calendarRef.current.setOpen(activeCalendar);
    }, [activeCalendar, isLocked]);
    const handleDatePickerChange = newDateStr => {
        onChange(dateConversionRules_1.convertToYMD(newDateStr));
        return setActiveCalendar(false);
    };
    // reset dates to todays day
    const setToday = () => {
        if (readOnly)
            return;
        onChange(dateConversionRules_1.getTodayDateStr());
    };
    /**
     * Here forwardRef enables us to pass the ref down to children component
     * where the parent is a state component (e.g: react-datepicker).
     */
    const CustomInput = react_1.forwardRef((_props, ref) => (jsx_runtime_1.jsx("div", Object.assign({ className: classes.iconInput, onClick: () => (readOnly ? null : setActiveCalendar(!activeCalendar)), "data-cy": "forms-js-calendar" }, { children: jsx_runtime_1.jsx(icons_1.Icon, { name: activeCalendar ? 'CalendarFill' : 'Calendar', size: 32, ref: ref }, void 0) }), void 0)));
    const disabled = readOnly || isLocked;
    return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.root }, { children: [!hideLabel && (jsx_runtime_1.jsxs("label", Object.assign({ htmlFor: id }, { children: [required && jsx_runtime_1.jsx("strong", { children: "*" }, void 0), label] }), void 0)),
            jsx_runtime_1.jsxs("div", Object.assign({ className: classes.dateWrapper }, { children: [jsx_runtime_1.jsxs("div", Object.assign({ className: classes.dateInput }, { children: [jsx_runtime_1.jsx("input", { id: id, type: "date", value: value, onChange: e => onChange(e.target.value), readOnly: disabled, onClick: e => e.preventDefault(), "data-error": error, "data-disabled": disabled, required: required, "data-cy": "forms-js-date-manual" }, void 0),
                            !isLocked && todayVisible && (jsx_runtime_1.jsx("p", Object.assign({ className: classes.dateToday, onClick: setToday, "data-cy": "forms-js-date-today" }, { children: "Today" }), void 0))] }), void 0),
                    !isLocked && (jsx_runtime_1.jsx(react_datepicker_1.default, { selected: value && !error ? dateConversionRules_1.convertToDate(value) : null, onChange: handleDatePickerChange, dateFormat: "dd/MM/yyyy", calendarClassName: classes.calendar, showPopperArrow: false, shouldCloseOnSelect: true, locale: "en", popperClassName: classes.calendarPuppet, readOnly: readOnly, ref: calendarRef, onClickOutside: () => setActiveCalendar(false), placeholderText: "dd/mm/yyyy", customInput: jsx_runtime_1.jsx(CustomInput, {}, void 0), disabledKeyboardNavigation: true }, void 0))] }), void 0)] }), void 0));
};
exports.DateEntry = DateEntry;
exports.default = lodash_flowright_1.default(withInlineValidation_1.default, react_jss_1.default(dateEntry_style_1.default))(exports.DateEntry);
//# sourceMappingURL=index.js.map